import { Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import AbstractShape from "@/components/AbstractShape";
import { goToIntake } from "@/lib/intake";
import useSEO from "@/lib/useSEO";
import { breadcrumbSchema } from "@/lib/schema";

export default function Contact() {
  useSEO({
    title: "Contact Melbi Wellness | Support & Patient Questions",
    description:
      "Get in touch with Melbi Wellness support for eligibility, prescription, and account questions. We respond within 1 business day.",
    url: "https://melbiwellness.com/contact",
    jsonLd: [
      breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Contact", url: "/contact" },
      ]),
    ],
  });
  return (
    <div data-testid="contact-page">
      <section className="relative">
        <AbstractShape variant="gradient-cream" colors={["#F5E6D3", "#E8D5C4", "#FAF9F6"]} className="absolute inset-0" testId="contact-hero-bg" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 md:pt-24 md:pb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8A9A92]">Contact</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight text-[#2C2B29] max-w-3xl">
            We'd love to hear from you.
          </h1>
          <p className="mt-5 text-[#5E5C58] text-lg leading-relaxed max-w-2xl">
            For questions, partnerships, or media, reach out below. Please do not include personal medical information.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="bg-white rounded-3xl p-6 md:p-12 border border-[#E8E5DF] text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-[#F3F1EC] flex items-center justify-center">
            <Mail size={24} className="text-[#C96A4E]" />
          </div>
          <h2 className="mt-5 font-display text-2xl md:text-3xl font-semibold tracking-tight text-[#2C2B29]">
            Email us directly
          </h2>
          <p className="mt-3 text-[#5E5C58]">
            We typically respond within a few business days.
          </p>
          <a
            href="mailto:hello@melbiwellness.com"
            data-testid="contact-email-link"
            className="mt-6 inline-flex items-center justify-center bg-[#C96A4E] text-white rounded-full px-8 py-4 text-base font-semibold hover:bg-[#B35A40] transition-colors"
          >
            hello@melbiwellness.com
          </a>
          <p className="mt-6 text-xs text-[#5E5C58] leading-relaxed max-w-xl mx-auto">
            Please do not include protected health information in your email. For medical emergencies, call 911 or visit your nearest emergency department.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 text-center">
        <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-[#2C2B29]">
          Ready to get started?
        </h2>
        <button
          data-testid="contact-start-now-cta"
          className="mt-5 inline-flex items-center justify-center bg-white text-[#2C2B29] rounded-full px-8 py-4 text-base font-semibold border border-[#E8E5DF] hover:bg-[#F3F1EC] transition-colors" type="button" onClick={goToIntake}>
          Start now
          <ArrowRight size={18} className="ml-2" />
        </button>
      </section>
    </div>
  );
}
